import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DividerComponent, ItemComponent, ListDetailComponent, SwitchComponent, TileComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-form-step-advanced-config',
	imports: [TranslatePipe, TileComponent, ItemComponent, ListDetailComponent, SwitchComponent, DividerComponent],
	templateUrl: './form-step-advanced-config.component.html',
	styleUrl: './form-step-advanced-config.component.scss',
})
export class FormStepAdvancedConfigComponent {
	@Input() required = false;
	@Input() requiredLocked = false;
	@Input() showMatchOcr = true;
	@Input() matchOcrEnabled = false;
	@Input() matchOcrLocked = false;

	@Output() requiredChange = new EventEmitter<boolean>();
	@Output() matchOcrChange = new EventEmitter<boolean>();
}
